import { createContext } from 'react';
import { ISignalrContext } from './types';

export default createContext<ISignalrContext | undefined>(undefined);
